import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { faCalendarAlt, faHeartbeat, faQuestion } from '@fortawesome/free-solid-svg-icons';
import { faEnvelopeOpen, faCopy } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './NavButtons.module.css'
import { MCCategories } from '_constants';

class HeaderNavButtons extends React.Component {
    render() {
        return (
            <div>
                <div style={{ padding: 5 }}>
                    <span style={{ paddingRight: 5 }}>
                        <Link to="/dashboard">
                            <div className={styles.therapist_dashboard_button + " fa-layers fa-fw"} title='Therapist Dashboard'>
                                <FontAwesomeIcon icon={faCalendarAlt} transform="shrink-6" color="white" />
                            </div>
                        </Link>
                    </span>

                    <span style={{ paddingRight: 5 }}>
                        <Link to="/messagecenter">
                            <span className={styles.message_center_button + " fa-layers fa-fw"} title='Message Center'>
                                <FontAwesomeIcon icon={faEnvelopeOpen} transform="shrink-6" color="white" />
                                {this.props.unreadCount > 0 ? <span className={styles.counter}>{this.props.unreadCount}</span> : ""}
                            </span>
                        </Link>
                    </span>

                    <span style={{ paddingRight: 5 }}>
                        <Link to="/patientcarecenter">
                            <div className={styles.patient_care_center_button + " fa-layers fa-fw"} title='Patient Care Center'>
                                <FontAwesomeIcon icon={faHeartbeat} transform="shrink-6" color="white" />
                            </div>
                        </Link>
                    </span>

                    <span style={{ paddingRight: 5 }}>
                        <Link to="/reportcenter">
                            <div className={styles.report_center_button + " fa-layers fa-fw"} title='Report Center'>
                                <FontAwesomeIcon icon={faCopy} transform="shrink-6" color="white" />
                            </div>
                        </Link>
                    </span>

                    <span style={{ paddingRight: 0 }}>
                        <Link to="/helpcenter">
                            <div className={styles.help_center_button + " fa-layers fa-fw"} title='Help Center'>
                                <FontAwesomeIcon icon={faQuestion} transform="shrink-6" color="white" />
                                {this.props.helpCenterUnreadCount > 0 ? <span className={styles.counter}>{this.props.helpCenterUnreadCount}</span> : ""}
                            </div>
                        </Link>
                    </span>
                </div>

                <div className={styles.env}>
                    <i>
                        {'v.' + process.env.REACT_APP_VERSION + (process.env.REACT_APP_ENV !== 'production' ? (' ' + process.env.REACT_APP_ENV + ' ' + process.env.REACT_APP_API_URI) : '')}
                    </i>
                </div>


            </div>
        );
    }
}

function getUnreadCount(state, category) {
    return state.entities[category] ? Object.keys(state.entities[category]).filter(key => { return state.entities[category][key].isRead === false }).length : 0;
}

function mapStateToProps(state) {
    let unreadCount = 0;
    Object.keys(MCCategories)
        .forEach(x => {
            if (MCCategories[x].enabled && MCCategories[x].includeInMsgCount)
                unreadCount += getUnreadCount(state, MCCategories[x].entityKey);
        })

    // TODO: determine this unread count based on contents of unread release notes in state
    const helpCenterUnreadCount = 0;

    return {
        unreadCount: unreadCount,
        helpCenterUnreadCount: helpCenterUnreadCount
    };
}


const connectedHeaderNavButtons = connect(mapStateToProps)(HeaderNavButtons);
export { connectedHeaderNavButtons as HeaderNavButtons };
